// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"dddc88182d509c07","9260":"eda6806606eb26cf","9682":"b69095ad25cd29c4"}[chunkId] + ".js";
};